module.exports = __webpack_public_path__ + "media/images/action_delete-6e950a22e1e1f67e4513dbef48716d56.png";